/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetLodgingQueryResponse,
  GetLodgingPathParams,
  GetLodging404,
} from '../types/GetLodging'

function getGetLodgingUrl({
  lodging_id,
}: {
  lodging_id: GetLodgingPathParams['lodging_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/places/lodging/${lodging_id}/` as const,
  }
  return res
}

/**
 * @summary Get a lodging chain
 * {@link /api/v1/places/lodging/:lodging_id/}
 */
export async function getLodging(
  { lodging_id }: { lodging_id: GetLodgingPathParams['lodging_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetLodgingQueryResponse,
    ResponseErrorConfig<GetLodging404>,
    unknown
  >({
    method: 'GET',
    url: getGetLodgingUrl({ lodging_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
